import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import BaseMixer from "@/router/views/BaseMixer";
import simplebar from "simplebar-vue";
import { PAReviewModule } from "@/store/modules/paReview.module";
import { IPAReviewItemDetailDTO } from "@/store/models/paReview/paReviewItemDetailDTO";
import { PAReviewRejectionReasonModel } from "@/store/models/paReview/paReviewRejectionReasonDTO";
import Swal from "sweetalert2";
let TakeActions = /** @class */ (() => {
    var _a;
    let TakeActions = class TakeActions extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.pageIsLoading = false;
            this.rejectedReason = "";
        }
        sendProcessAction(action, rejectObject) {
            if (action == "deliver" || action == "deliverToAll") {
                if (this.reviewDetails.isDeliverablePostClientAssignment) {
                    this.checkForAction(action, "Do you want to deliver the review after client assignment?");
                }
                else if (this.reviewDetails.isMakeClientAssignment) {
                    this.checkForAction(action, "Do you want to deliver the review without client assignment?");
                }
                else {
                    this.$emit("processaction", action, rejectObject);
                }
            }
            else {
                this.$emit("processaction", action, rejectObject);
            }
        }
        checkForAction(action, title) {
            Swal.fire({
                customClass: {
                    container: "remove-swal2-container",
                    title: "remove-swal2-title",
                    popup: "remove-swal2-popup",
                    icon: "remove-swal2-icon",
                },
                text: `You won't be able to revert this!`,
                icon: "warning",
                title: title,
                showCancelButton: true,
                confirmButtonColor: "#f46a6a",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
            }).then((result) => {
                if (result.value) {
                    return this.saveAction(action, null);
                }
                return false;
            });
        }
        saveAction(action, rejectObject) {
            this.$emit("processaction", action, rejectObject);
        }
        get openedByClient() {
            return PAReviewModule.openedByClient;
        }
        rejectReview() {
            this.validate("reviewRejectionObserver").then((response) => {
                if (response) {
                    const reject = new PAReviewRejectionReasonModel();
                    reject.reviewId = this.reviewDetails.reviewCycleId;
                    reject.rejectedReason = this.rejectedReason.trim();
                    this.sendProcessAction("reject", reject);
                }
            });
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IPAReviewItemDetailDTO !== "undefined" && IPAReviewItemDetailDTO) === "function" ? _a : Object)
    ], TakeActions.prototype, "reviewDetails", void 0);
    TakeActions = __decorate([
        Component({
            name: "TakeActions",
            components: {
                Loader,
                simplebar,
            },
        })
    ], TakeActions);
    return TakeActions;
})();
export default TakeActions;
